import request from '../../utils/request'
// 专家列表
export function getListCheckExpert(data: any): Promise<any> {
  return request({
    method: 'GET',
    url: 'manage/checkExpert/list',
    type: 'params',
    data
  })
}
// 新增修改专家预约
export function submitCheckExpert(data: any): Promise<any> {
  return request({
    url: 'manage/checkExpert/submit',
    method: 'POST',
    data
  })
}
// 删除专家
export function deleteCheckExpert(data: any): Promise<any> {
  return request({
    url: 'manage/checkExpert/delete',
    method: 'POST',
    type: 'params',
    data
  })
}
// 查询已经设置的时间段
export function getScheduleListByIdCheckExpert(data: any): Promise<any> {
  return request({
    method: 'GET',
    url: 'manage/checkExpert/scheduleListById',
    type: 'params',
    data
  })
}
// 号源保存接口
export function saveScheduleCheckExpert(data: any): Promise<any> {
  return request({
    url: 'manage/checkExpert/saveSchedule',
    method: 'POST',
    data
  })
}
// 专家预约记录查询
export function getCheckExpertAppointmentList(data: any): Promise<any> {
  return request({
    method: 'GET',
    url: 'manage/checkExpertAppointment/list',
    type: 'params',
    data
  })
}
// 专家预约导出
export function DownLoadExportResultExcel(data: any) {
  return request({
    method: "GET",
    url: 'manage/checkExpertAppointment/exportResultExcel',
    type: 'params',
    data
  })

}
